import { Link } from 'react-router-dom';
import { LayoutGrid, Shield, Library as LibraryIcon } from 'lucide-react';
import ThemeToggle from './ThemeToggle';
import { useAuth } from '../contexts/AuthContext';

const ADMIN_EMAIL = (process.env.REACT_APP_ADMIN_EMAIL || '').trim().toLowerCase();

export default function Layout({ title, actions, children }) {
  const { user } = useAuth();
  const userEmail = (user?.email || '').trim().toLowerCase();
  const isAdmin = !!userEmail && userEmail === ADMIN_EMAIL;

  return (
    <div className="flex flex-col h-screen bg-background">
      {/* Topbar - 56px */}
      <header className="h-14 shrink-0 border-b border-border bg-card flex items-center justify-between px-5 z-30">
        <div className="flex items-center gap-3">
          <Link to="/" className="flex items-center text-foreground hover:opacity-80 transition-opacity" aria-label="Kinote">
            <img
              src="/logo.svg"
              alt="Kinote"
              className="h-7 w-auto"
              onError={(e) => { e.currentTarget.onerror = null; e.currentTarget.src = '/logo.png'; }}
            />
          </Link>
          {title && (
            <>
              <span className="text-border">/</span>
              <span className="text-sm text-muted-foreground font-medium">{title}</span>
            </>
          )}
        </div>
        <div className="flex items-center gap-2">
          {title && title !== 'Tableau de bord' && (
            <Link to="/" className="flex items-center gap-1.5 text-xs text-muted-foreground hover:text-foreground transition-colors mr-3">
              <LayoutGrid className="w-3.5 h-3.5" />
              Projets
            </Link>
          )}
          {user && title !== 'Bibliothèque' && (
            <Link to="/library" className="flex items-center gap-1.5 text-xs text-muted-foreground hover:text-foreground transition-colors mr-3" data-testid="library-link">
              <LibraryIcon className="w-3.5 h-3.5" />
              Bibliothèque
            </Link>
          )}
          {isAdmin && (
            <Link to="/admin" className="flex items-center gap-1.5 text-xs text-muted-foreground hover:text-primary transition-colors mr-1" data-testid="admin-link">
              <Shield className="w-3.5 h-3.5" />
              Admin
            </Link>
          )}
          {actions}
          <ThemeToggle />
        </div>
      </header>
      <main className="flex-1 overflow-hidden">
        {children}
      </main>
    </div>
  );
}
